import type { FaireProductEntity } from "../../entity_types/product";

export const p_s8vuzth92s: FaireProductEntity = {
  token: "p_s8vuzth92s",
  type: "product",
  name: "Small Gemstone Cat Figurine – Carved Crystal Animal Statue",
  brandToken: "b_at4bwf6pjp",
  brandName: "Keystone Crystals",
  imageUrl:
    "https://cdn.faire.com/fastly/baf1ff97fd1bfdeab3f29a5252feb6eb431100442fdc13b28b1def19110add80.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cc8277e35be6524be0a15a1784ceb64e28817688797db4f396d325a544b5a8a2.jpeg",
    "https://cdn.faire.com/fastly/62f2c85a84a9584cd77015ec2f244265f339cd5a4ee264d8996e6d3467fcbe61.jpeg",
    "https://cdn.faire.com/fastly/7a303fbb7a3fbee73528555e021cd5a7053ec47b7946079624719c3de154e587.jpeg",
    "https://cdn.faire.com/fastly/71100b07ed4632b205be30aab4be634df88e3a90633512c9020a5ca47229b735.jpeg",
    "https://cdn.faire.com/fastly/0d6d5863ce04532bd3988493ec84a5bb9534fc812bfc09704630a9cda42537c1.jpeg",
    "https://cdn.faire.com/fastly/274bf161c484360088e431fe0a7d06ebfb6180db119a4ca78eefe7d92ec551d8.jpeg",
    "https://cdn.faire.com/fastly/8dfc99f962f037305c7a7ca8714f06f8291f7aaebd27fa64b03d9136db53e95a.jpeg",
    "https://cdn.faire.com/fastly/62475c190bb9fe9aca310e142a699322b3ceb107fc6e22a1127dcd125e6eb936.jpeg",
  ],
  priceDollars: 3.19,
  description:
    "These small gemstone cat figurines are carved from stones, making it a unique collectible and a charming addition to any crystal or animal lover’s collection. Available in assorted gemstones, each cat figurine showcases the natural beauty and energy of the stone. Ideal for metaphysical shops, gift stores, and crystal collectors, these wholesale gemstone cat carvings are perfect for display, altar décor, or as a thoughtful gift.\n\nPlease note that these are the highest priority for the factory to make and will be here near the end of April as we ship by boat to keep the cost down.\n\nSold by the each with a minimum of 3 approximately 1 inch.\n",
  tags: [],
  msrpDollars: 6.37,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:44.046Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
